module.exports = __webpack_public_path__ + "static/media/GC Murray Headshot.dc0e30b9.png";